import React, { ReactElement } from "react";

import {
  COVER_RATIO_IMAGE,
  StyledColorCover,
  coverManagement,
  Placeholder,
} from "./shared";
import { UploadIcon } from "../../../components/Icons";
import { SkeletonLoader } from "../../../components/Loaders";
import { StackedCardCover as Cover } from "../../../components/StackedCard";

/**
 * ImageCard — a full-bleed image and little else. Cover-management controls
 * (collapse, remove) appear on hover; there is no other chrome. Fixed-box in
 * production (host sets width AND height, the cover scales aspect-locked); shown
 * here in the auto-height shell with a reserved image aspect ratio.
 */

export interface ImageCardProps {
  color?: string;
  src?: string;
}

export const ImageCard = ({
  color = "#F0997B",
  src,
}: ImageCardProps): ReactElement => (
  <Cover
    aspectRatio={COVER_RATIO_IMAGE}
    topRightSlot={coverManagement({ removeLabel: "Remove image" })}
  >
    {src ? <img src={src} alt="" /> : <StyledColorCover $color={color} />}
  </Cover>
);

/* ---- placeholder + skeleton ---- */

/* The placeholder doubles as the drop target (visual only here). */
export const ImagePlaceholder = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement>
): ReactElement => (
  <Placeholder
    icon={<UploadIcon />}
    label="Drop an image or click to upload"
    height={168}
    dashed
    {...props}
  />
);

export const ImageSkeleton = (): ReactElement => (
  <Cover aspectRatio={COVER_RATIO_IMAGE}>
    <SkeletonLoader style={{ width: "100%", height: "100%" }} />
  </Cover>
);
